import React, { Component, useEffect } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Button, Table } from "react-bootstrap";
//import { Modal } from "react-bootstrap";
//import { Editor } from "@tinymce/tinymce-react";
import JoditEditor from "jodit-react";

class NovinkyAdmin extends Component {
  state = { novinka: {} };

  componentDidMount = () => {
    this.nahrajNovinky();
  };

  nahrajNovinky = async () => {
    const novinky = await httpService.post(
      config.apiEndpoint + "novinky/vypis.php"
    );
    this.setState({ novinky: novinky.data.novinky, loaded: true });
  };

  upravitNovinku = (attr, val) => {
    let { novinka } = this.state;
    novinka[attr] = val;
    console.log("attr", attr, "val", val);
    this.setState({ novinka });
  };

  ulozitNovinku = async () => {
    const { novinka, novinkaEdit } = this.state;
    await httpService.post(config.apiEndpoint + "novinky/editaceNovinky.php", {
      novinka,
      novinka_id: novinkaEdit,
    });
    this.nahrajNovinky();
    this.setState({ showNovinkaEdit: false });
  };

  editNovinka = (novinka_id) => {
    const { novinky } = this.state;
    let novinka = {};
    if (novinka_id === "-1") {
      novinka = {};
    } else {
      novinka = novinky.find((n) => n.novinka_id === novinka_id);
    }
    console.log("novinka", novinka);
    this.setState({ novinkaEdit: novinka_id, showNovinkaEdit: true, novinka });
  };

  smazatNovinku = async (novinka_id, confirmed) => {
    if (confirmed) {
      await httpService.post(config.apiEndpoint + "novinky/smazat.php", {
        novinka_id,
      });
      this.nahrajNovinky();
    } else {
      if (window.confirm("Skutečně smazat?")) {
        this.smazatNovinku(novinka_id, true);
      }
    }
  };

  render() {
    const { novinky, loaded, novinkaEdit, showNovinkaEdit, novinka } =
      this.state;

    return (
      <React.Fragment>
        {showNovinkaEdit && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-8">
                <small>Nadpis</small>
                <input
                  type="text"
                  className="form-control"
                  value={novinka.nadpis}
                  onChange={(e) =>
                    this.upravitNovinku("nadpis", e.target.value)
                  }
                />
              </div>
              <div className="col-md-2">
                <small>Interní novinka</small>
                <div>
                  <input
                    type="checkbox"
                    value="1"
                    onChange={(e) =>
                      this.upravitNovinku(
                        "interni",
                        e.target.checked ? "1" : "0"
                      )
                    }
                    checked={novinka.interni === "1"}
                  />{" "}
                  Ano
                </div>
              </div>
              <div className="col-md-2">
                <small>Veřejná novinka</small>
                <div>
                  <input
                    type="checkbox"
                    value="1"
                    onChange={(e) =>
                      this.upravitNovinku(
                        "verejna",
                        e.target.checked ? "1" : "0"
                      )
                    }
                    checked={novinka.verejna === "1"}
                  />{" "}
                  Ano
                </div>
              </div>
              <div className="col-md-5">
                <small>Úvod</small>
                {/*<Editor
                  key={"uvod_editor"}
                  apiKey={config.tinyMCEAPIkey}
                  init={{
                    plugins: "link image code",
                    height: 400,
                  }}
                  name="uvod"
                  id="uvod"
                  value={novinka.uvod}
                  outputFormat="html"
                  onEditorChange={(text) => this.upravitNovinku("uvod", text)}
                />*/}
                <JoditEditor
                  key={"uvod_editor"}
                  value={novinka.uvod}
                  onBlur={(text) => this.upravitNovinku("uvod", text)}
                />
              </div>
              <div className="col-md-7">
                <small>Obsah novinky</small>
                {/*<Editor
                  key={"novinka_editor"}
                  apiKey={config.tinyMCEAPIkey}
                  init={{
                    plugins: "link image code",
                    height: 400,
                  }}
                  name="novinka"
                  id="novinka"
                  value={novinka.novinka}
                  outputFormat="html"
                  onEditorChange={(text) =>
                    this.upravitNovinku("novinka", text)
                  }
                />*/}
                <JoditEditor
                  key={"novinka_editor"}
                  value={novinka.novinka}
                  onChange={(text) => this.upravitNovinku("novinka", text)}
                />
              </div>
              <div
                className="col-md-12 text-right mt-3 mb-3 pb-3"
                style={{ borderBottom: "solid 1px #eee" }}
              >
                {" "}
                <Button
                  onClick={this.ulozitNovinku}
                  disabled={
                    !(novinka && novinka.nadpis && novinka.nadpis !== "")
                  }
                >
                  Uložit
                </Button>
                <Button
                  variant="danger"
                  className="ml-1"
                  onClick={() =>
                    this.setState({ showNovinkaEdit: false, novinka_id: false })
                  }
                >
                  Storno
                </Button>
              </div>
            </div>
          </React.Fragment>
        )}
        <Button className="mb-3" onClick={() => this.editNovinka("-1")}>
          Nová novinka
        </Button>
        {loaded &&
          (novinky && novinky.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Novinka ID</th>
                  <th>Napis</th>
                  <th>Interní</th>
                  <th>Veřejná</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {novinky.map((n) => (
                  <tr key={n.novinka_id}>
                    <td>
                      <a
                        href="javascript:;"
                        variant="inline"
                        onClick={() => this.editNovinka(n.novinka_id)}
                      >
                        {n.novinka_id}
                      </a>
                    </td>
                    <td>{n.nadpis}</td>
                    <td>
                      {n.interni === "1" ? (
                        <span className="text-success">Ano</span>
                      ) : (
                        <span className="text-danger">Ne</span>
                      )}
                    </td>
                    <td>
                      {n.verejna === "1" ? (
                        <span className="text-success">Ano</span>
                      ) : (
                        <span className="text-danger">Ne</span>
                      )}
                    </td>
                    <td>
                      <Button onClick={() => this.smazatNovinku(n.novinka_id)}>
                        Smazat
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="alert alert-danger">Nic tu není...</div>
          ))}
      </React.Fragment>
    );
  }
}

export default NovinkyAdmin;
